import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useTabVisibility from 'hooks/useTabVisibility'
import { fetchAttractionOffers } from 'actions/ExperienceActions'
import { EmptyArray } from 'lib/array/arrayUtils'

interface UseAttractionOffersResult {
  offerIds: Array<string>
  total: number
  fetching: boolean
  error?: string
}

function useAttractionOffers(attractionId?: string): UseAttractionOffersResult {
  const dispatch = useAppDispatch()
  const key = attractionId ? `attraction-offers-${attractionId}` : undefined
  const result = useAppSelector(
    state => key ? state.experience.attractionOffers?.[key] : undefined,
  )

  const isTabActive = useTabVisibility()

  useEffect(() => {
    if (!attractionId || !isTabActive) return
    dispatch(fetchAttractionOffers(attractionId))
  }, [attractionId, isTabActive, dispatch])

  return {
    offerIds: result?.offerIds ?? EmptyArray,
    total: result?.total ?? 0,
    fetching: result?.fetching ?? (!!attractionId && !result),
    error: result?.error,
  }
}

export default useAttractionOffers
